// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld-base';
import _ from 'underscore';
import $ from 'jquery';
import credentialsComponentFieldHtml from 'text!html/credentialsComponentField.html';
import 'jquery-ui';
import 'jquery-ui-touch';

const credentialsComponentFieldTemplate = _.template(credentialsComponentFieldHtml);

myw.CredentialsComponent = myw.MywClass.extend({
    /**
     * @class Handles UI for getting login credentials
     * for a datasource or server
     *
     * @constructs
     */
    initialize() {},

    setAuthFields(authOptions) {
        const username = authOptions.user;

        this.empty();
        this._addAuthFields(authOptions.auth_fields);
        this._clearFields(username, authOptions.user_readonly);
        if (username) {
            this._setFocusOnFirstFieldNotUsername();
        }
    },

    /**
     * Construct the html for the component
     */
    buildHtml() {
        this._componentElement = $('<div/>', {
            id: 'credentials-component'
        });
        return this._componentElement;
    },

    /**
     * Remove all the fields from the component
     */
    empty() {
        this._componentElement.empty();
    },

    /**
     * Returns the credentials set in the component
     */
    getCredentials() {
        const credentials = {};
        _.each(this._authFieldIds, id => {
            const inputElement = this._elementForId(id);
            credentials[id] = inputElement.val();
        });
        return credentials;
    },

    /*
     * Add UI for the user to enter the required credentials
     * @param  {Array<authField>}  authfields  List of auth fields retrieved from server
     */
    _addAuthFields(authFields) {
        this._authFieldIds = [];
        _.each(authFields, this._addAuthField.bind(this));
    },

    /*
     * Add UI for a single auth field
     * @param  {authField}  authfield   An auth field
     */
    _addAuthField(authField) {
        const fieldHtml = credentialsComponentFieldTemplate({
            id: authField.id,
            // We get messages for labels from the 'login' message group,
            // not from this class's message group
            label: myw.msg('login', authField.label),
            type: authField.type
        });
        this._componentElement.append(fieldHtml);
        this._authFieldIds.push(authField.id);
    },

    /*
     * Clear the fields in the dialog. If the 'user' field exists, set its value to
     * the specified user name and set the field editable (or not) based on the
     * specified readonly flag
     * @param  {string}  username   Initial username
     * @param  {boolean} readonly   If true, set the username to be read only
     */
    _clearFields(username, readonly) {
        _.each(this._authFieldIds, id => {
            let value = '';
            const inputElement = this._elementForId(id);
            if (id == 'user') {
                value = username;
                if (readonly === true) {
                    inputElement.attr('disabled', true);
                } else {
                    inputElement.attr('disabled', false);
                }
            }
            inputElement.val(value);
        });
    },

    /*
     * Get the input element corresponding to the specified id
     * @param  {string}  id  Field ID
     */
    _elementForId(id) {
        const inputElementId = `#credentials-${id}`;
        return this._componentElement.find(inputElementId);
    },

    /*
     * Set the focus on the first field which isn't the 'user' field
     */
    _setFocusOnFirstFieldNotUsername() {
        const idRequiringFocus = _.find(this._authFieldIds, id => id != 'user');
        if (idRequiringFocus) {
            const inputElement = this._elementForId(idRequiringFocus);
            inputElement.focus();
        }
        // else no fields or only username field
    }
});

export default myw.CredentialsComponent;
